import { gql } from '@apollo/client';

import { USER_FRAGMENT } from '../fragments';

export const SET_USER_IDENTITY = gql`
  ${USER_FRAGMENT}
  mutation setUserIdentity(
    $email: String
    $dateOfBirth: String
    $firstName: String
    $lastName: String
    $phoneNumber: String
    $address: UserAddressInput
    $countryOfCitizenship: String
    $residenceStatus: UserResidenceStatus
  ) {
    setUserIdentity(
      input: {
        email: $email
        dateOfBirth: $dateOfBirth
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
        address: $address
        countryOfCitizenship: $countryOfCitizenship
        residenceStatus: $residenceStatus
      }
    ) {
      ...UserFragment
    }
  }
`;

export const SET_USER_TAX_PROFILE = gql`
  ${USER_FRAGMENT}
  mutation setUserTaxProfile(
    $taxId: String!
    $taxIdType: UserTaxIdType!
    $countryOfTaxResidence: String!
    $stateOfTaxResidence: String!
  ) {
    setUserTaxProfile(
      input: {
        taxId: $taxId
        taxIdType: $taxIdType
        countryOfTaxResidence: $countryOfTaxResidence
        stateOfTaxResidence: $stateOfTaxResidence
      }
    ) {
      ...UserFragment
    }
  }
`;

export const ADD_BENEFICIARY = gql`
  mutation addBeneficiary(
    $firstName: String
    $lastName: String
    $dateOfBirth: DateOfBirth
    $type: BeneficiaryType!
  ) {
    addBeneficiary(
      input: { firstName: $firstName, lastName: $lastName, dateOfBirth: $dateOfBirth, type: $type }
    ) {
      id
      type
      firstName
      lastName
      dateOfBirth
      goals {
        id
        name
        description
        type
        targetAmountInCents
        currentAmountInCents
        startDate
        endDate
        status
      }
    }
  }
`;
